import React, { useState } from 'react'
import Header from '../Header/Header'
import './Banner.css'
import bannerMobile from '../../assets/images/bannerMobile.png'
import bannerBgLeft from '../../assets/images/bannerBgLeft.png'
import { useDialog } from '../DialogProvider/DialogProvider';
import { useNavigate } from 'react-router-dom';
function Banner() {
    const { openDialog } = useDialog();
    const navigate = useNavigate();

    return (
        <div className='Banner'>
            <Header />
            <div className='content'>
                <div className='text-content'>
                    <div className='theme-heading-text'>Tick Tock, Time to Rock Your Productivity with BrainyClock!</div>
                    <p className='theme-text-small-16'>Streamline operations, enhance productivity, and simplify time tracking for your business.</p>
                    <div className='d-flex gap-24 btn-container'>
                        <button className='menu-btn-theme' onClick={() => navigate("/signup")} >Start Your Free Trial</button>
                        <button className='menu-outline-btn-theme' onClick={() => openDialog('bookdemo')}>Book a Demo Today!</button>
                    </div>
                </div>
                <div className='img-content d-lg-block d-none'>
                    <img src={bannerMobile} alt="" />
                </div>
            </div>

            <div className="bannerBgLeft"></div>
            <div className="bannerBgRight"></div>
            {/* <img src={bannerBgLeft} alt="" className='bannerBgLeft' /> */}
        </div>
    )
}

export default Banner
